export default __webpack_public_path__ + "static/media/025-squid.e4b70c2f.svg";